import { render, staticRenderFns } from "./video-detail.vue?vue&type=template&id=5745285a&scoped=true"
import script from "./video-detail.vue?vue&type=script&lang=js"
export * from "./video-detail.vue?vue&type=script&lang=js"
import style0 from "./video-detail.vue?vue&type=style&index=0&id=5745285a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5745285a",
  null
  
)

export default component.exports